module.exports = __webpack_public_path__ + "img/img-3-3.03a35153.webp";